import React, { useContext, useEffect, useState } from "react";
import { useRouter } from "next/router";
import MoviesSlider from "@/components/movies/MoviesSlider";
import * as Text from "@/components/text";
import Link from "next/link";
import ReactMarkdown from "react-markdown";
import FilterContextProvider, {
  FilterContext,
  FilterDispatchContext,
  handleChangeFilter,
  clearAll,
} from "../../stores/FilterContextProvider";
import { localeTexts } from "@/utils/locale";

export default function Movies({
  films,
  themeName,
  themeDescription,
  topicId = "",
  simple = false,
}) {
  const [newMovies, setNewMovies] = useState([]);
  const filters = useContext(FilterContext);
  const dispatch = useContext(FilterDispatchContext);
  const router = useRouter();
  const [locale, setLocale] = useState("es-MX");
  const t = localeTexts[locale]?.movies || {};
  // Configuration for theme name prefixes
  const excludedPrefixes = {
    'es-MX': ['mex', 'línea'],
    'en-US': ['mex', 'line']
  };

     // Sync locale with URL and localStorage
  useEffect(() => {
    if (!router.isReady) return;

    const urlLocale = router.query.locale;
    const storedLocale = typeof window !== "undefined" 
      ? localStorage.getItem("amb-locale") 
      : null;
    const finalLocale = urlLocale || storedLocale || "es-MX";

    setLocale(finalLocale);
    localStorage.setItem("amb-locale", finalLocale);
  }, [router.isReady, router.query.locale]);

    const shouldShowPrefix = !excludedPrefixes[locale]?.some(word => 
    themeName.toLowerCase().includes(word.toLowerCase())
  );

  useEffect(() => {
    if (films.length >= 1) {
      setNewMovies(films);
    }
  }, [films]);

  return (
    <>
      {films?.length ? (
        <div className="grid grid-cols-2">
          <div>
            <Text.Headline className="sm:text-[24px]" size="md" as="h3">
              {shouldShowPrefix && `${t.about || "Sobre"} `}
              {themeName}
            </Text.Headline>
            <ReactMarkdown className={"prose mb-6 prose-h2:uppercase"}>
              {themeDescription}
            </ReactMarkdown>
          </div>
          <div className="flex flex-row-reverse items-center sm:pr-5">
            <Link
              href={`/catalogo?iniciativa=todas-las-iniciativas&temas=${themeName}`}
            >
              <button className="border-b-2 border-solid border-gray-500/50 font-semibold">
                {t.viewAll || "Ver todas"}
              </button>
            </Link>
          </div>
        </div>
      ) : null}
      <div className="m-auto">
        {newMovies.length >= 1 ? (
          <MoviesSlider
            simple={simple}
            movies={newMovies
              .filter((m) => m.attributes.locale === "es-MX")
              .slice(0, 9)}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
